module.exports = __webpack_public_path__ + "assets/2f7df698398d75cdc0cfc5e291a3a2ab.mp3";